import { render } from "./BannerComponent.vue?vue&type=template&id=01dbe304"
const script = {}

import "./BannerComponent.vue?vue&type=style&index=0&id=01dbe304&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__